import { Stack, Box } from "@mui/material";
import { WorkspaceLoader } from "../../components/WorkspaceLoader";
import { Sidebar } from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import { Copilot } from "../../components/Copilot/Copilot";

export const WorkspaceLayout: React.FC = () => {
  return (
    <WorkspaceLoader>
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "10px",
          overflowY: "auto",
          overflowX: "hidden",
          width: "100%",
          height: "100%",
          flex: 1,
          minWidth: 0,
          maxWidth: "100%",
        }}
      >
        <Stack direction="row" width="100%" flex={1} minWidth={0}>
          <Sidebar />
          <Box flex={1} minWidth={0} maxWidth="100%">
            <Outlet />
          </Box>
        </Stack>
      </Box>
      <Copilot />
    </WorkspaceLoader>
  );
};
